import {
  forbiddenCharacters,
  isEmpty,
  validateLength,
} from '../utility/validation';
import { FIELD_TYPES } from './fieldTypes';

export const NEW_DOCUMENT_TYPE_VALUES = {
  name: '',
  is_mandatory: true,
  self_upload: true,
};

export const DOCUMENT_EXPIRY_NOTIFICATION_PERIODS = {
  ONE_WEEK: {
    id: 7,
    key: 'oneWeek',
  },
  ONE_MONTH: {
    id: 30,
    key: 'oneMonth',
  },
  TWO_MONTHS: {
    id: 60,
    key: 'twoMonths',
  },
};

export const DOCUMENT_EXPIRY_NOTIFICATION_PERIOD_OPTIONS = [
  DOCUMENT_EXPIRY_NOTIFICATION_PERIODS.ONE_WEEK,
  DOCUMENT_EXPIRY_NOTIFICATION_PERIODS.ONE_MONTH,
  DOCUMENT_EXPIRY_NOTIFICATION_PERIODS.TWO_MONTHS,
];

export const DEFAULT_DOCUMENT_EXPIRY_NOTIFICATION_PERIOD =
  DOCUMENT_EXPIRY_NOTIFICATION_PERIODS.ONE_MONTH.id;

export const getDocumentExpiryNotificationOptions = labels =>
  DOCUMENT_EXPIRY_NOTIFICATION_PERIOD_OPTIONS.map(period => ({
    id: period.id,
    name: labels[period.key],
  }));

export const DOCUMENT_TYPE_FIELDS = [
  {
    name: 'name',
    required: true,
    type: FIELD_TYPES.TEXT,
    translationKey: 'documentName',
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
      {
        validator: forbiddenCharacters,
        type: 'forbiddenCharacters',
      },
      {
        validator: value => validateLength(value, 0, 128),
        type: 'maxLength',
      },
    ],
  },
  {
    name: 'is_mandatory',
    translationKey: 'isMandatory',
    type: FIELD_TYPES.CHECKBOX,
    isControlled: true,
    isDisabledCheck: values => !values.documentName,
    shouldRender: () => true,
  },
  {
    name: 'self_upload',
    translationKey: 'isSelfUpload',
    type: FIELD_TYPES.CHECKBOX,
    isControlled: true,
    isDisabledCheck: values => !values.documentName,
    shouldRender: () => true,
  },
];
